import {
  get,
  post,
  put,
} from '../configApi'
export async function gettokenfirebase(params) {
  return await get(`/notification/gettokenfirebase`, params)
}
export async function gettokenfirebasecompany(params) {
  return await get(`/notification/gettokenfirebasecompany`, params)
}
export async function getUserByschedule(params) {
  return await get(`/notification/getstudentbyschedule`, params)
}
export async function getExamListInCourse(params) {
  return await get(`/notification/listexam`, params)
}
export async function createNotice(body) {
  return await post(`/notification/sendnotification`, body)
}
export async function createNoticeWithSendTime(body) {
  return await post(`/notification/saveschedule`, body)
}
export async function updateNotice(body) {
  return await put(`/notification/manage/update`, body)
}
export async function createNoticeToSendNow(body) {
  return await post(`/notification/sendnow`, body)
}
export async function getListNoticeLive(params) {
  return await get(`/notification/listschedulelive`, params)
}